import { prepareDocumentsAndPagesForCurrentState } from '../utils';
import {
  narrowPreparedStateInputsForCrossDevice,
  selectCrossDeviceRequest,
  isCrossDeviceRequestMode
} from './crossDevicePreparedState';

export { selectCrossDeviceRequest, isCrossDeviceRequestMode };

const preparedStateMemo = {
  lastInputs: null,
  lastResult: null
};

function getPreparedStateInputs(state) {
  return {
    crossDeviceRequest: state.crossDeviceRequest,
    requestedDocuments: state.requestedDocuments,
    forms: state.forms,
    scannedDocuments: state.scannedDocuments,
    documentsStatus: state.documentsStatus,
    documentConditions: state.documentConditions,
    requestPages: state.requestPages,
    signatures: state.signatures,
    successSentKeys: state.successSentKeys,
    rejectedDocuments: state.rejectedDocuments
  };
}

function arePreparedStateInputsEqual(prev, next) {
  return (
    prev.crossDeviceRequest === next.crossDeviceRequest &&
    prev.requestedDocuments === next.requestedDocuments &&
    prev.forms === next.forms &&
    prev.scannedDocuments === next.scannedDocuments &&
    prev.documentsStatus === next.documentsStatus &&
    prev.documentConditions === next.documentConditions &&
    prev.requestPages === next.requestPages &&
    prev.signatures === next.signatures &&
    prev.successSentKeys === next.successSentKeys &&
    prev.rejectedDocuments === next.rejectedDocuments
  );
}

export const selectPreparedState = state => {
  const nextInputs = getPreparedStateInputs(state);

  if (
    preparedStateMemo.lastInputs &&
    arePreparedStateInputsEqual(preparedStateMemo.lastInputs, nextInputs)
  ) {
    return preparedStateMemo.lastResult;
  }

  const preparedInputs = narrowPreparedStateInputsForCrossDevice(nextInputs);

  const result = prepareDocumentsAndPagesForCurrentState(
    preparedInputs.requestedDocuments,
    preparedInputs.forms,
    preparedInputs.scannedDocuments,
    preparedInputs.documentsStatus,
    preparedInputs.documentConditions,
    preparedInputs.requestPages,
    preparedInputs.signatures,
    preparedInputs.successSentKeys,
    preparedInputs.rejectedDocuments
  );

  preparedStateMemo.lastInputs = nextInputs;
  preparedStateMemo.lastResult = result;

  return result;
};
